"use client";

export interface BiteBstAnalysis {
  source: "bst";
  name: string;
  score: number;
  grade: string;
  peerStats: { key: string; topPct: number | null; val: string | null }[];
  peerCount: number;
  generatedAt: string | null;
}

export function BiteBstMetrics({ analysis, variant = "card" }: { analysis?: BiteBstAnalysis | null; variant?: "card" | "report" }) {
  const stats = (analysis?.peerStats || []).filter((stat) => stat.topPct != null);
  if (!stats.length) return null;
  return <div className={`bite-bulls-card__metrics bite-bst-metrics--${variant}`}>
    {variant === "card" && <div className="bite-bulls-card__metric-label">동종업계 대비</div>}
    {stats.map((stat) => <div className="bite-bulls-card__metric" key={stat.key}>
      <span>{stat.key}</span>
      <span className="bite-bulls-card__metric-bar" aria-hidden="true"><span style={{ width: `${Math.max(4, 100 - stat.topPct!)}%` }} /></span>
      <strong>상위 {stat.topPct}%</strong>
      {variant === "report" && stat.val && <small className="bite-bst-metrics__value">원본 값 {stat.val}</small>}
    </div>)}
  </div>;
}

export function BiteBstReport({ analysis }: { analysis?: BiteBstAnalysis | null }) {
  if (!analysis || !analysis.peerStats.some((stat) => stat.topPct != null)) return null;
  const timestamp = analysis.generatedAt ? new Date(analysis.generatedAt) : null;
  const date = timestamp && Number.isFinite(timestamp.getTime()) ? new Intl.DateTimeFormat("ko-KR", { year: "numeric", month: "long", day: "numeric", timeZone: "Asia/Seoul" }).format(timestamp) : null;
  return <section className="bite-bst-report" aria-label="BST의 동종업계 비교 지표">
    <header><span>BST 원본 지표</span><h3>동종업계와 비교한 기업 지표</h3><p>수익성과 안정성, 성장을 동종업계와 비교했습니다.</p></header>
    <BiteBstMetrics analysis={analysis} variant="report" />
    {date && <p className="bite-bst-report__source">{date}에 생성된 BST 분석 기준입니다.</p>}
  </section>;
}
